import './Anchor.scss'

import classNames from 'classnames'
import React, { AnchorHTMLAttributes, ReactNode } from 'react'

export interface AnchorProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string
  children?: ReactNode
  variant?: 'primary' | 'secondary'
  size?: 'small' | 'medium'
}

function buildModifierClasses(size: string, variant: string) {
  const variantClass = `three-sixty-anchor--${variant}`

  return `${variantClass} three-sixty-anchor--${size}`
}

// Currently only supports anchors styled as buttons
export default function Anchor(props: AnchorProps) {
  const { className, children, variant = 'primary', size = 'medium', ...otherProps } = props
  const mergedClassName = classNames('three-sixty-anchor', className, buildModifierClasses(size, variant))

  return (
    <a className={mergedClassName} {...otherProps}>
      {children}
    </a>
  )
}
